import { env } from 'env';

export const FORMATTED_DATE_FORMAT = 'D MMM YYYY, HH:mm';

export const isProduction = () => {
  return env.env === 'production';
};

export const moveItemInArray = <T>(arr: T[], fromIndex: number, toIndex: number) => {
  const element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
  return arr;
};

export const formatLink = (url: string) => {
  if (url.startsWith('https://') || url.startsWith('http://')) {
    return url;
  } else {
    return 'https://' + url;
  }
};
